import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { newsParam } from '../models/walai';
import { ApiConfig, ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {
  private _apiconfig: ApiConfig;
  private apiUrl = '';
  private token = '';
  header = new HttpHeaders();

  constructor(
    private http: HttpClient,
    private configService: ConfigService,
  ) { 
    this._apiconfig =  this.configService.apiConfig;
    this.apiUrl = this._apiconfig.url;
    this.token = this._apiconfig.token;
    this.header.append('Content-Type', 'application/json');
  }


  public getWalaiMaterailType(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/api/MaterialType`, 
      {headers: this.header});
  }
  public getWalaiCollection(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/api/Collection`,
      {headers: this.header});
  }
  public getWalaiLang(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/api/getlange`,
      {headers: this.header});
  }
  public getWalaiCountry(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/api/Country`, 
      {headers: this.header});
  }

  getNewsList(val: newsParam): Observable<any>{
    return this.http.post<any>(`${this.apiUrl}/api/getNews`, val, 
      { headers: this.header });
  }
  
  public getNews(id:number): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/api/getNews/${id}`,
      {headers: this.header});
  }


  public getBookTha(isbn: string) {
    var _cover = 'assets/images/bookcover/noimage.jpg';
    if (isbn != '') {
      let p1 = isbn.substring(0, 6);
      let p2 = isbn.substring(6, 9);
      _cover =
        'https://images-se-ed.com/ws/Storage/Originals/' +
        p1 +
        '/' +
        p2 +
        '/' +
        isbn +
        'L.jpg';
    }

    return _cover

  }

  public getISBN(isbn: string) {
    // var _cover = 'assets/images/bookcover/noimage.jpg';
     var isbn13 = isbn;
     if (isbn.match(/^\d+$/) !== null) {
     } else {
       if (isbn.length > 13) {
         var isbnlis;
         isbnlis = isbn.split(',');
         isbnlis.forEach((element) => {
           try {
             if (isbn13.length != 13) {
               isbn13 = element.substring(0, 13);
             }
           } catch (error) {}
         });
       }
 
     }
 
     return isbn13
    
   }

  public getBookEng(isbn: string,noimg :string) {
   // var _cover = 'assets/images/bookcover/noimage.jpg';
    var isbn13 = isbn;
    if (isbn.match(/^\d+$/) !== null) {
    } else {
      if (isbn.length > 13) {
        var isbnlis;
        isbnlis = isbn.split(',');
        isbnlis.forEach((element) => {
          try {
            if (isbn13.length != 13) {
              isbn13 = element.substring(0, 13);
            }
          } catch (error) {}
        });
      }

    }
    if(isbn13==''){
      return noimg;
    }else{
      return 'https://covers.openlibrary.org/b/isbn/' + isbn13 + '-L.jpg';
    }
   
  }

     // CHECK IF IMAGE EXISTS
     checkIfImageExists(url, callback) {
      const img = new Image();
      img.src = url;
  
      if (img.complete) {
        callback(true);
      } else {
        img.onload = () => {
          callback(true);
        };
  
        img.onerror = () => {
          callback(false);
        };
      }
    }
 

}
